import AWS from 'aws-sdk';
import { saveAs } from 'file-saver';
import JSZip from "jszip"; // To save the ZIP file

AWS.config.update({
    accessKeyId: process.env.REACT_APP_S3_KEY_ID,
    secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
    region: process.env.REACT_APP_S3_REGION
});

export const s3 = new AWS.S3();

export const uploadToS3 = (params) => {
    s3.upload(params, (error, data) => {
        if (error) {
            console.error('Error uploading JSON file:', error);
        } else {
            console.log('JSON file uploaded successfully:', data.Location);
        }
    });
}

export const fetchWhitelabelFolders = async () => {
    const params = {
        Bucket: process.env.REACT_APP_BUCKET_NAME,
        Delimiter: '/',
    };
    try {
        const data = await s3.listObjectsV2(params).promise();
        const folders = await Promise.all(data.CommonPrefixes.map(async (folder, i) => {
            let appDetails = await getAppDetails(folder.Prefix);
            return {folderName: folder.Prefix, appName: folder.Prefix.split('---')[0], id: (i + 1), submitDate: appDetails?.submitDate, businessEmail: appDetails?.businessEmail}
        }));
        return folders ?? [];
    } catch (error) {
        console.error('Error fetching folders:', error);
    }
}

export const getAppDetails = async (folderName) => {
    try {
        const appDetailsParams = {
            Bucket: process.env.REACT_APP_BUCKET_NAME,
            Key: `${folderName}appDetails.json`,
        };

        const appDetailsData = await s3.getObject(appDetailsParams).promise();

        return JSON.parse(appDetailsData.Body.toString('utf-8'));
    } catch (error) {
        return null
    }
}

export const fetchWhitelableZip = async (folderName) => {
    const params = {
        Bucket: process.env.REACT_APP_BUCKET_NAME,
        Prefix: folderName,
    };

    try {
        const data = await s3.listObjectsV2(params).promise();
        console.log('data:', data);
        const zip = new JSZip();

        for (const obj of data.Contents) {
            const getObjectParams = {
                Bucket: process.env.REACT_APP_BUCKET_NAME,
                Key: obj.Key,
            };

            const fileData = await s3.getObject(getObjectParams).promise();
            zip.file(obj.Key.replace(folderName, ''), fileData.Body);
        }

        const content = await zip.generateAsync({ type: 'blob' });
        saveAs(content, `${folderName}.zip`);
    } catch (error) {
        console.error('Error fetching whitelabel zip:', error);
    }
}

export const getOnBoardingData = async () => {
    const params = {
        Bucket: process.env.REACT_APP_BUCKET_NAME,
        Key: 'onBoardingMembers.json',
    };

    try {
        const data = await s3.getObject(params).promise();
        const fileContent = data.Body.toString('utf-8'); // Convert buffer to string
        return JSON.parse(fileContent); // Assuming the file is JSON
    } catch (error) {
        console.error('Error fetching on boarding members:', error);
    }
}

export const updateOnBoardingData = async (newMembers) => {
    const params = {
        Bucket: process.env.REACT_APP_BUCKET_NAME,
        Key: 'onBoardingMembers.json',
        ContentType: 'application/json',
        Body: JSON.stringify(newMembers)
    };

    try {
        await s3.putObject(params).promise();
        console.log('onBoardingMembers.json updated successfully');
    } catch (error) {
        console.error('Error updating onBoardingMembers.json:', error);
    }
}

export const generateZipFromFormData = (formData, jsonData) => {
    const zip = new JSZip();
    zip.file('appDetails.json', JSON.stringify(jsonData));

    for (const key of formData.keys()) {
        if (formData.get(key)) {
            const file = formData.get(key);
            zip.file(file.name, file);
        }
    }

    return zip.generateAsync({ type: 'blob' });
};